module.exports = __webpack_public_path__ + "static/DontOpenYourEyes0-12ad77fc0d0226bc6b3da8abe8f221f7.png";